import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatauserPipe } from '../../pipe/datauser/datauser.pipe';
import { DatafieldPipe } from '../../pipe/datafield/datafield.pipe';
import { DatacommodityPipe } from '../../pipe/datacommodity/datacommodity.pipe';
import { DataequipmentPipe } from '../../pipe/dataequipment/dataequipment.pipe';
import { DatacontainerPipe } from '../../pipe/datacontainer/datacontainer.pipe';
import { Source } from '../_models/alert/common/common/source';
import { MemoExpiration } from '../_models/alert/types/memoExpiration';
import { DeviceParameter } from '../_models/alert/types/deviceParameter';
import { ContainerBalance } from '../_models/alert/types/containerBalance';
import { EquipmentAlertGeneric } from '../_models/alert/types/equipmentAlertGeneric';
import { LoadQuantity } from '../_models/alert/types/loadQuantity';
import { ConditionAnd } from '../_models/alert/types/conditionAnd';
import { SatelliteAlert } from '../_models/alert/types/satelliteAlert';
import { IrrigationAlert } from '../_models/alert/types/irrigationAlert';
import { DiseaseAlert } from '../_models/alert/types/DiseaseAlert';
import { DefenceZoneService } from './diseases/defenceZone.service';
import { IrrigationZoneService } from './irrigation/irrigationZone.service';
import { InsectsZoneService } from './insects/insectsZone.service';

export const InsectTypologyAlert = {
  CAPTURE: 'CAPTURE',
  DEGREE_OF_DEVELOPMENT: 'DEGREE_OF_DEVELOPMENT',
  ALERT_THRESHOLDS: 'ALERT_THRESHOLDS',
  PHEROMONE_LEVEL: 'PHEROMONE_LEVEL',
  LEVEL_OF_THE_SHEET: 'LEVEL_OF_THE_SHEET',
};

@Injectable()
export class RulesInPhrasesService {
  alertTypes = Source;
  constructor(
    private translate: TranslateService,
    private datacontainer: DatacontainerPipe,
    private dataequipmentPipe: DataequipmentPipe,
    private datacommodityPipe: DatacommodityPipe,
    private datafieldPipe: DatafieldPipe,
    private datauserPipe: DatauserPipe,
    private datePipe: DatePipe,
    private irrigationZoneService: IrrigationZoneService,
    private defenceZoneService: DefenceZoneService,
    private insectsZoneService: InsectsZoneService
  ) {}

  getPhrasesByAlertRules(rules: Array<any>): Array<any> {
    const ruleList = [];
    if (rules && rules.length > 0) {
      rules.forEach((rule) => {
        // TODO implementare anche l'OR -> anche se per ora non viene utilizzato
        if (rule.type === 'And') {
          let concatDescription: string = '';
          const concatRule: Array<any> = [];
          let alertLine = null;
          rule.and.forEach((condition) => {
            if (!concatDescription) {
              concatDescription = this.translate.instant('alertsNew.phrases.label_when', {}) + ' ';
            } else {
              concatDescription += ',' + ' ';
            }
            if (condition.type === this.alertTypes.FIELD_ACTIVITY_TYPE) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                condition.value === 'all' ? 'ACTIVITY_ALERT_type_all' : 'ACTIVITY_ALERT_type',
                'select_activity_2.'
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_DONE) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                'ACTIVITY_ALERT_status',
                'alertLabel.valueAlert.label_done.'
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_AUTHORIZATION) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                condition.value ? 'ACTIVITY_ALERT_authorized' : 'ACTIVITY_ALERT_not_authorized',
                ''
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_PHENOLOGICAL_STAGE) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                'ACTIVITY_ALERT_phenological_state',
                'select_phenologicalstage.'
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_PRODUCT_NAME) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                'ACTIVITY_ALERT_phenological_product',
                condition.value
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_PRODUCT_BIO_USE) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                condition.value
                  ? 'ACTIVITY_ALERT_phenological_biological'
                  : 'ACTIVITY_ALERT_phenological_not_biological',
                ''
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_PRODUCT_REVOKED) {
              if (condition.value) {
                alertLine = this.getPhraseByFieldActivity(
                  condition,
                  concatDescription,
                  'ACTIVITY_ALERT_phenological_revock',
                  ''
                );
              } else {
                alertLine = this.getPhraseByFieldActivity(
                  condition,
                  concatDescription,
                  'ACTIVITY_ALERT_phenological_not_revock',
                  ''
                );
              }
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_USERS) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                'ACTIVITY_ALERT_phenological_users',
                ''
              );
            } else if (condition.type === this.alertTypes.FIELD_ACTIVITY_FIELDS) {
              alertLine = this.getPhraseByFieldActivity(
                condition,
                concatDescription,
                'ACTIVITY_ALERT_phenological_fields',
                ''
              );
            } else if (condition.type === this.alertTypes.MEMO_EXPIRATION) {
              alertLine = this.getPhraseByDateAlert(condition);
            } else if (condition.type === this.alertTypes.DEVICE_LONG_PARAMETER) {
              alertLine = this.getPhraseByxSenseAlert(condition);
            } else if (condition.type === this.alertTypes.DEVICE_DOUBLE_PARAMETER) {
              alertLine = this.getPhraseByxSenseAlert(condition);
            } else if (condition.type === this.alertTypes.CONTAINER_BALANCE) {
              alertLine = this.getPhraseByWarehouseAlert(condition);
            } else if (condition.type === this.alertTypes.EQUIPMENT_INSPECTION_DATE) {
              alertLine = this.getPhraseByEquipmentAlert(condition);
            } else if (condition.type === this.alertTypes.EQUIPMENT_TECHNICAL_CHECK_DATE) {
              alertLine = this.getPhraseByEquipmentAlert(condition);
            } else if (condition.type === this.alertTypes.EQUIPMENT_TASK_SEND) {
              alertLine = this.getPhraseByTaskSendAlert(condition);
            } else if (condition.type === this.alertTypes.EQUIPMENT_TASK_RECEIVED) {
              alertLine = this.getPhraseByTaskReceivedAlert(condition);
            } else if (condition.type === this.alertTypes.LOAD_QUANTITY) {
              alertLine = this.getPhraseByLoadAlert(condition);
            } else if (condition.type === this.alertTypes.SATELLITI_MEAN_VARIATION) {
              alertLine = this.getPhraseBySatelliteAlert(
                condition,
                this.alertTypes.SATELLITI_MEAN_VARIATION
              );
            } else if (condition.type === this.alertTypes.SATELLITI_MEAN) {
              alertLine = this.getPhraseBySatelliteAlert(condition, this.alertTypes.SATELLITI_MEAN);
            } else if (condition.type === this.alertTypes.IRRIGATION_ADVICE_TRUE) {
              alertLine = this.getPhraseByIrrigationAlert(
                condition,
                this.alertTypes.IRRIGATION_ADVICE_TRUE
              );
            } else if (condition.type === this.alertTypes.DISEASE_PROTECTION) {
              alertLine = this.getPhraseByDiseaseAlert(condition, 'DISEASE_PROTECTION');
            } else if (condition.type === this.alertTypes.DISEASE_RISK) {
              alertLine = this.getPhraseByDiseaseAlert(condition, 'DISEASE_RISK');
            } else if (condition.type === this.alertTypes.EQUIPMENT_GEOFENCINGIN) {
              alertLine = this.getPhraseByGeofencingInAlert(condition);
            } else if (condition.type === this.alertTypes.EQUIPMENT_GEOFENCINGOUT) {
              alertLine = this.getPhraseByGeofencingOutAlert(condition);
            } else if (condition.type === InsectTypologyAlert.CAPTURE) {
              alertLine = this.getPhraseByInsectTypologyCaptureAlert(
                condition,
                this.alertTypes.INSECTS_ALERT
              );
            } else if (condition.type === InsectTypologyAlert.DEGREE_OF_DEVELOPMENT) {
              alertLine = this.getPhraseByDegreeofDevelopmentTypologyAlert(
                condition,
                this.alertTypes.INSECTS_ALERT
              );
            } else if (condition.type === InsectTypologyAlert.ALERT_THRESHOLDS) {
              alertLine = this.getPhraseByThresholdsTypeAlert(
                condition,
                this.alertTypes.INSECTS_ALERT
              );
            } else if (condition.type === InsectTypologyAlert.PHEROMONE_LEVEL) {
              alertLine = this.getPhraseByPheromoneLevelTypeAlert(
                condition,
                this.alertTypes.INSECTS_ALERT
              );
            } else if (condition.type === InsectTypologyAlert.LEVEL_OF_THE_SHEET) {
              alertLine = this.getPhraseBySheetLevelTypeAlert(
                condition,
                this.alertTypes.INSECTS_ALERT
              );
            }

            concatDescription = alertLine.phrase;
            concatRule.push(alertLine.data);
          });
          // Replace dell'ultima virgola
          alertLine.phrase = alertLine.phrase.replace(
            /,([^,]*)$/,
            ' ' + this.translate.instant('alertsNew.phrases.label_and', {}) + '$1' + ' '
          );
          // Data diventa un array
          const conditionAnd = new ConditionAnd();
          conditionAnd.and = concatRule;
          alertLine.data = conditionAnd;
          ruleList.push(alertLine);
        }
        // TODO - pathogen
        /*
				if (rule.type === this.alertTypes.PATHOGEN_ALERT) {
								ruleList.push(this.getPhraseByPathogenAlert(rule));
				}
				*/
      });
    }
    return ruleList;
  }

  getPhraseByFieldActivity(rule: any, concatText, typeActivity, typeValue): any {
    let valueReplace = {};
    let valueNot = null;
    if (rule.type === 'Not') {
      valueNot = rule;
      rule = rule.not;
    }
    if (
      typeActivity !== 'ACTIVITY_ALERT_phenological_users' &&
      typeActivity !== 'ACTIVITY_ALERT_phenological_fields'
    ) {
      valueReplace = {
        value:
          typeActivity !== 'ACTIVITY_ALERT_phenological_product' &&
          typeActivity !== 'ACTIVITY_ALERT_phenological_product'
            ? this.translate.instant(typeValue + rule.value, {})
            : typeValue,
      };
    } else if (typeActivity === 'ACTIVITY_ALERT_phenological_users') {
      let users = '';
      rule.value.forEach((userId, index) => {
        if (rule.value.length - 1 === index) {
          users +=
            this.datauserPipe.transform(userId).firstName +
            ' ' +
            this.datauserPipe.transform(userId).lastName;
        } else {
          users +=
            this.datauserPipe.transform(userId).firstName +
            ' ' +
            this.datauserPipe.transform(userId).lastName +
            ', ';
        }
      });
      valueReplace = {
        users: users.replace(
          /,([^,]*)$/,
          ' ' + this.translate.instant('alertsNew.phrases.label_and', {}) + '$1' + ' '
        ),
      };
    } else if (typeActivity === 'ACTIVITY_ALERT_phenological_fields') {
      let fieldName = '';
      rule.value.forEach((fieldId) => {
        const field = this.datafieldPipe.transform(fieldId);
        if (field && field.name) {
          fieldName += ' ' + field.name;
        }
      });
      valueReplace = {
        fields: fieldName,
      };
    }
    const textPhrase = this.translate.instant('alertsNew.phrases.' + typeActivity, valueReplace);

    return {
      data: valueNot ? valueNot : rule,
      type: 'ACTIVITY_ALERT',
      phrase: concatText + textPhrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: '',
    };
  }

  getPhraseByDateAlert(rule: MemoExpiration): any {
    const params = {
      datetime: this.datePipe.transform(rule.value, 'dd/MM/yyyy'),
    };
    // tslint:disable-next-line:prefer-const
    const phrase = this.translate.instant('alertsNew.phrases.' + rule.type, params);

    return {
      data: rule,
      type: this.alertTypes.DATE_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: '',
    };
  }

  getPhraseByxSenseAlert(rule: DeviceParameter): any {
    let textPhrase = '';
    const replace = {
      parameter: null,
      condition: null,
      quantity: null,
      unit: null,
      value: null,
      days: null,
      device: null,
    };
    replace.device = rule.deviceName ? rule.deviceName : '...';
    replace.parameter = rule.parameter
      ? this.translate.instant('sense.data.grid.' + rule.parameter, {})
      : '...';
    replace.condition = rule.operator
      ? this.translate.instant('alertsNew.conditions.' + rule.operator, {}).toLowerCase()
      : '...';
    replace.quantity = rule.value || rule.value === 0 ? rule.value : '...';
    replace.unit = rule.unit ? rule.unit : '...';

    const days = null;
    if (rule.period) {
      const periodDay = rule.period.split('d');
      const periodHour = rule.period.split('h');
      if (periodDay.length > 1) {
        replace.days = periodDay[0] + ' ' + this.translate.instant('form.select.day_plural', {});
      } else if (periodHour.length > 1) {
        replace.days = periodHour[0] + ' ' + this.translate.instant('form.select.hour_plural', {});
      }
    }
    ////  console.log(replace.days)
    replace.days = replace.days
      ? ', ' + this.translate.instant('alertsNew.phrases.XSENSE_ALERT_DAYS', replace)
      : '';
    ////  console.log(replace.days)
    textPhrase += ' ' + this.translate.instant('alertsNew.phrases.XSENSE_ALERT_REQUIRED', replace);

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.XSENSE_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.XSENSE_ALERT,
      phrase: textPhrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByWarehouseAlert(rule: ContainerBalance): any {
    const params = {
      parameter: null,
      condition: null,
      quantity: null,
      unit: null,
    };

    params.parameter = rule.containerId
      ? this.datacontainer.transform(rule.containerId, null).name
      : '...';

    params.condition = rule.operator
      ? this.translate.instant('alertsNew.conditions.' + rule.operator, {}).toLowerCase()
      : '...';

    params.quantity = rule.value;

    params.unit = rule.unit ? this.translate.instant('alertsNew.unitList.' + rule.unit, {}) : '...';

    const phrase = this.translate.instant('alertsNew.phrases.WAREHOUSE_ALERT', params);

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.WAREHOUSE_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.WAREHOUSE_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByEquipmentAlert(rule: EquipmentAlertGeneric): any {
    const params = {
      equipment: null,
      revisionType: null,
      days: null,
    };

    params.equipment = rule.equipmentId
      ? this.dataequipmentPipe.transform(rule.equipmentId).name
      : '...';
    params.revisionType = this.translate.instant('alertsNew.equipmentParameters.' + rule.type, {});
    params.days = rule.value;

    const phrase = this.translate.instant('alertsNew.phrases.' + 'EQUIPMENT_ALERT', params);

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.EQUIPMENT_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.EQUIPMENT_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByTaskSendAlert(rule: EquipmentAlertGeneric): any {
    const params = {
      equipment: null,
    };

    params.equipment = rule.equipmentId
      ? this.dataequipmentPipe.transform(rule.equipmentId).name
      : '...';

    const phrase = this.translate.instant(
      'alertsNew.phrases.' + 'EQUIPMENT_TASK_SEND_ALERT',
      params
    );

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.EQUIPMENT_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.EQUIPMENT_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByTaskReceivedAlert(rule: EquipmentAlertGeneric): any {
    const params = {
      equipment: null,
    };

    params.equipment = rule.equipmentId
      ? this.dataequipmentPipe.transform(rule.equipmentId).name
      : '...';

    const phrase = this.translate.instant(
      'alertsNew.phrases.' + 'EQUIPMENT_TASK_RECEIVED_ALERT',
      params
    );

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.EQUIPMENT_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.EQUIPMENT_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByGeofencingInAlert(rule: any): any {
    console.log(rule);
    const params = {
      equipment: null,
    };

    params.equipment = rule.equipmentId
      ? this.dataequipmentPipe.transform(rule.equipmentId).name
      : '...';

    const phrase =
      this.translate.instant('alertsNew.phrases.label_when', {}) +
      ' ' +
      this.translate.instant('alertsNew.phrases.EQUIPMENT_GEOFENCINGIN', {}) +
      ' ' +
      rule.areaRadius +
      'Km';

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.EQUIPMENT_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.EQUIPMENT_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByGeofencingOutAlert(rule: any): any {
    const params = {
      equipment: null,
    };

    params.equipment = rule.equipmentId
      ? this.dataequipmentPipe.transform(rule.equipmentId).name
      : '...';

    const phrase =
      this.translate.instant('alertsNew.phrases.label_when', {}) +
      ' ' +
      this.translate.instant('alertsNew.phrases.EQUIPMENT_GEOFENCINGOUT', {}) +
      ' ' +
      rule.areaRadius +
      'Km';

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.EQUIPMENT_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.EQUIPMENT_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseByLoadAlert(rule: LoadQuantity): any {
    // tslint:disable-next-line:prefer-const
    const params = {
      parameter: null,
      condition: null,
      quantity: null,
      unit: null,
    };

    params.parameter = rule.commodityId
      ? this.translate.instant(
          'select_commodity.' + this.datacommodityPipe.transform(rule.commodityId).name,
          {}
        )
      : '...';

    params.condition = rule.operator
      ? this.translate.instant('alertsNew.conditions.' + rule.operator, {}).toLowerCase()
      : '...';

    params.quantity = rule.value;

    params.unit = rule.unit ? this.translate.instant('alertsNew.unitList.' + rule.unit, {}) : '...';

    const phrase = this.translate.instant('alertsNew.phrases.' + 'LOAD_ALERT', params);

    let textPhraseIncomplete = '';
    if (rule.incomplete) {
      textPhraseIncomplete = this.translate.instant('alertsNew.phrases.LOAD_ALERT_INCOMPLETE');
    }

    return {
      data: rule,
      type: this.alertTypes.LOAD_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
      phraseIncomplete: textPhraseIncomplete,
    };
  }

  getPhraseBySatelliteAlert(rule: SatelliteAlert, typologyParam: string): any {
    // tslint:disable-next-line:prefer-const
    const params = {
      type: null,
      fieldId: null,
      index: null,
      condition: null,
      quantity: null,
      percent: null,
    };

    // Quando la Media/Variazione Media per il campo Nome campo per l’indice NDVI  è maggiore di 32.23
    // "SATELLITE_ALERT_INCOMPLETE": "Inserire il Campo, l'indice, la condizione e il valore"
    // "SATELLITE_ALERT": "Quando la {{type}} per il campo '{{fieldId}}', per l'indice {{index}} è {{condition}} di {{quantity}}{{percent}}"

    if (rule.fieldId) {
      params.type =
        typologyParam === 'SpaceSenseSatelliteMeanVariation'
          ? this.translate.instant('satellite.mean_variation', {})
          : this.translate.instant('satellite.mean', {});

      const fieldName = this.datafieldPipe.transform(String(rule.fieldId)).name;
      params.fieldId = fieldName ? fieldName : ' ...';

      params.index = rule.index ? rule.index : '...';

      params.condition = rule.operator
        ? this.translate.instant('alertsNew.conditions.' + rule.operator, {}).toLowerCase()
        : '...';

      params.quantity = rule.value ? rule.value : '...';

      params.percent = typologyParam === 'SpaceSenseSatelliteMeanVariation' ? '%' : '';

      const phrase = this.translate.instant('alertsNew.phrases.' + 'SATELLITE_ALERT', params);

      let textPhraseIncomplete = '';
      if (rule.incomplete) {
        textPhraseIncomplete = this.translate.instant(
          'alertsNew.phrases.SATELLITE_ALERT_INCOMPLETE'
        );
      }

      return {
        data: rule,
        type: this.alertTypes.SATELLITE_ALERT,
        phrase,
        incomplete: rule.incomplete ? true : false,
        phraseIncomplete: textPhraseIncomplete,
      };
    }
  }

  getPhraseByIrrigationAlert(rule: IrrigationAlert, typologyParam: string): any {
    // tslint:disable-next-line:prefer-const
    const params = {
      zoneId: null,
      days: null,
    };

    if (rule.zoneId) {
      const listZoneBehaviour = this.irrigationZoneService.list;
      listZoneBehaviour.forEach((listZone) => {
        listZone.forEach((zone) => {
          if (zone.id === rule.zoneId) {
            params.zoneId = zone.name;
          }
        });
      });
      //params.zoneId = rule.zoneId
      params.days = rule.range;

      const phrase = this.translate.instant('alertsNew.phrases.IRRIGATION_ADVICE_TRUE', params);

      let textPhraseIncomplete = '';
      if (rule.incomplete) {
        textPhraseIncomplete = this.translate.instant(
          'alertsNew.phrases.IRRIGATION_ADVICE_TRUE_INCOMPLETE'
        );
      }

      return {
        data: rule,
        type: this.alertTypes.IRRIGATION_ALERT,
        phrase,
        incomplete: rule.incomplete ? true : false,
        phraseIncomplete: textPhraseIncomplete,
      };
    }
  }

  getPhraseByDiseaseAlert(rule: DiseaseAlert, typologyParam: string): any {
    const params = {
      zoneId: null,
      days: null,
      pathogen: null,
      value: null,
    };

    if (rule.zoneId) {
      this.defenceZoneService.getOrFetchList().subscribe((listZone) => {
        if (listZone) {
          const matchingZone = listZone.find((zone) => zone.id === rule.zoneId);
          if (matchingZone) {
            params.zoneId = matchingZone.name;
          }
        }
      });

      const pathName = this.translate.instant('pathogens', {});
      const pathogenValue = pathName[rule.pathogen as any];

      if (pathogenValue) {
        params.pathogen = pathogenValue;
      } else {
        params.pathogen = rule.pathogen;
      }

      params.value = rule.value;
      params.days = rule.range;

      const phrase = this.translate.instant('alertsNew.phrases.' + typologyParam, params);

      let textPhraseIncomplete = '';
      if (rule.incomplete) {
        textPhraseIncomplete = this.translate.instant(
          'alertsNew.phrases.' + typologyParam + '_INCOMPLETE'
        );
      }

      return {
        data: rule,
        type: this.alertTypes.DISEASE_ALERT,
        phrase,
        incomplete: rule.incomplete ? true : false,
        phraseIncomplete: textPhraseIncomplete,
      };
    }
  }

  getPhraseByInsectTypologyCaptureAlert(rule: any, typologyParam: string) {
    // Quando il numero di catture per l’insetto XXXX  sono maggiori di ……
    const params = {
      insectId: null,
      condition: null,
      quantity: null,
    };

    params.insectId = rule.insectId
      ? this.translate.instant(
          'insects.select_name_insects.' + this.insectsZoneService.getInsectById(rule.insectId).key,
          {}
        )
      : '...';
    params.condition = this.translate
      .instant('alertsNew.conditions.' + rule.condition, {})
      .toLowerCase();
    params.quantity = rule.value;

    const phrase = this.translate.instant('alertsNew.phrases.INSECT_CAPTURE_ALERT', params);

    return {
      data: rule,
      type: this.alertTypes.INSECTS_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
    };
  }

  getPhraseByDegreeofDevelopmentTypologyAlert(rule: any, typologyParam: string) {
    // Quando l’insetto è nello stato di uovo (larva, 1°volo, ecc…). Avvisami 1 giorno prima
    const params = {
      insectId: null,
      days: null,
      state: null,
    };
    params.insectId = rule.insectId
      ? this.translate.instant(
          'insects.select_name_insects.' + this.insectsZoneService.getInsectById(rule.insectId).key,
          {}
        )
      : '...';
    params.state = rule.degreeofDevelopment
      ? this.translate.instant('insects.' + rule.degreeofDevelopment)
      : '...';
    params.days = rule.conditionDays;

    const phrase = this.translate.instant(
      'alertsNew.phrases.INSECT_DEGREE_OF_DEVELOPMENT_ALERT',
      params
    );

    return {
      data: rule,
      type: this.alertTypes.INSECTS_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
    };
  }

  getPhraseByThresholdsTypeAlert(rule: any, typologyParam: string) {
    // Avvisami quando si supera la soglia
    const params = {
      value: null,
    };

    params.value = rule.insectId
      ? this.translate.instant(
          'insects.select_name_insects.' + this.insectsZoneService.getInsectById(rule.insectId).key,
          {}
        )
      : '...';

    let phrase;

    if (rule.alertThreshold == 0) {
      phrase = this.translate.instant('insect_alert_thresholds.min_thresholds', {});
    } else {
      phrase = this.translate.instant('insect_alert_thresholds.max_thresholds', {});
    }

    return {
      data: rule,
      type: this.alertTypes.INSECTS_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
    };
  }

  getPhraseByPheromoneLevelTypeAlert(rule: any, typologyParam: string) {
    //Quando il livello del feromone è maggiore di 1 per l'insetto xxxxx. Avvisami 1 giorno prima
    const params = {
      insectId: null,
      days: null,
      condition: null,
      quantity: null,
    };

    params.insectId = rule.insectId
      ? this.translate.instant(
          'insects.select_name_insects.' + this.insectsZoneService.getInsectById(rule.insectId).key,
          {}
        )
      : '...';
    params.condition = this.translate
      .instant('alertsNew.conditions.' + rule.condition, {})
      .toLowerCase();
    params.quantity = rule.value;
    params.days = rule.conditionDays;

    const phrase = this.translate.instant('alertsNew.phrases.INSECT_PHEROMONE_LEVEL_ALERT', params);

    return {
      data: rule,
      type: this.alertTypes.INSECTS_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
    };
  }

  getPhraseBySheetLevelTypeAlert(rule: any, typologyParam: string) {
    //Quando il livello del foglio è maggiore di 1 per l'insetto xxxxx. Avvisami 1 giorno prima
    const params = {
      insectId: null,
      days: null,
      condition: null,
      quantity: null,
    };

    params.insectId = rule.insectId
      ? this.insectsZoneService.getInsectById(rule.insectId).key
      : '...';
    params.condition = this.translate
      .instant('alertsNew.conditions.' + rule.condition, {})
      .toLowerCase();
    params.quantity = rule.value;
    params.days = rule.conditionDays;

    const phrase = this.translate.instant(
      'alertsNew.phrases.INSECT_LEVEL_OF_THE_SHEET_ALERT',
      params
    );

    return {
      data: rule,
      type: this.alertTypes.INSECTS_ALERT,
      phrase,
      incomplete: rule.incomplete ? true : false,
    };
  }
}
